import { getProcessEnvs } from '../../utils';
import { RoktIdentityDetails } from './RoktPlacement.types';

export const buildRoktPlacementAttributes = (
  identity: RoktIdentityDetails,
  confirmationNumber: string
): Record<string, string | boolean> => {
  const { NEXT_PUBLIC_ROKT_SANDBOX, NEXT_PUBLIC_ROKT_BONVOY_OVERLAY } = getProcessEnvs();
  const sandbox = NEXT_PUBLIC_ROKT_SANDBOX !== 'false';
  const bonvoyOverlay = NEXT_PUBLIC_ROKT_BONVOY_OVERLAY !== 'false';

  const attributes: Record<string, string | boolean> = {
    // Rokt requires an ISO Alpha-2 country code; US keeps placement calls
    // valid when the booking data layer does not provide one.
    country: identity.countryCode || '',
    sandbox,
    bonvoyOverlay,
    confirmationNumber,
  };

  if (identity.firstName) {
    attributes.firstname = identity.firstName;
  }
  if (identity.email) {
    attributes.email_sha256 = identity.email;
  }

  return attributes;
};